module.exports = __webpack_public_path__ + "static/img/zycp_jineng_a.dd0d6bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/zycp_jineng_a.jpg
// module id = zSRE
// module chunks = 1